import { makeStyles } from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';

import { ReactComponent as Menu } from './hamburger_icon.svg';

const useStyles = makeStyles({
  icon: {
    width: 24,
    height: 24,
  },
});

export default function MenuIcon() {
  const classes = useStyles();

  return (
    <SvgIcon className={classes.icon} viewBox="0 0 24 24">
      <Menu />
    </SvgIcon>
  );
}
